import { AxiosRequestConfig } from 'axios'
import { Repository } from 'ecp/repositories/Repository'
import api from 'services/api'
import { IAntifraudApiEvent, IAntifraudParticipantsResponse, IAntifraudSavedReview, _resendableSolution } from 'egi/app/ProposalEgi/components/AntifraudAnalysis/antifraudAnalysisTypes'

class AntifraudEgiRepository extends Repository {
  async participants (proposalId: string, config?: AxiosRequestConfig) {
    return Repository.handle<IAntifraudParticipantsResponse>(() =>
      this.api.get(`${this.path}/${proposalId}/anti-fraude-status/participants`, config)
    )
  }

  async reconcileUnico (
    proposalId: string,
    participantRef: string,
    config?: AxiosRequestConfig
  ) {
    return Repository.handle<{ processId?: string }>(() =>
      this.api.post(
        `${this.path}/${proposalId}/participants/${encodeURIComponent(participantRef)}/unico/reconcile`,
        {},
        config
      )
    )
  }

  async manualReviewHistory (
    proposalId: string,
    participantRef: string,
    config?: AxiosRequestConfig
  ) {
    return Repository.handle<{ history: IAntifraudSavedReview[], apiEvents?: IAntifraudApiEvent[] }>(() =>
      this.api.get(
        `${this.path}/${proposalId}/participants/${encodeURIComponent(participantRef)}/manual-review/history`,
        config
      )
    )
  }

  async saveManualReview (
    proposalId: string,
    participantRef: string,
    data: FormData,
    config?: AxiosRequestConfig
  ) {
    return Repository.handle<{ participantRef: string, review: string, createdAt: string }>(() =>
      this.api.post(
        `${this.path}/${proposalId}/participants/${encodeURIComponent(participantRef)}/manual-review`,
        data,
        { ...config, headers: { ...config?.headers, 'Content-Type': 'multipart/form-data' } }
      )
    )
  }

  async resendParticipant (
    proposalId: string,
    participantRef: string,
    solution: _resendableSolution,
    config?: AxiosRequestConfig
  ) {
    return Repository.handle<{ participantRef: string, solution: _resendableSolution }>(() =>
      this.api.post(
        `${this.path}/${proposalId}/participants/${encodeURIComponent(participantRef)}/resend`,
        { solution },
        config
      )
    )
  }
}

export default new AntifraudEgiRepository({ api, path: '/rodobens-kyc' })
